import { ClinicalData } from "../../../../data-model/clinicalCondition";
import { TableData } from "../types";

/**
 * Maps API clinical condition entries to table rows for display.
 *
 * @param clinicalData - Clinical conditions payload from the order context.
 * @return Rows with ICD code, description, date, and matched J-codes string.
 */
export const generateTableData = (clinicalData: ClinicalData): TableData[] => {
  return Array.isArray(clinicalData?.entries)
    ? clinicalData.entries.map((entry) => ({
        icd10_code: entry.icd10_code,
        icd10_desc: entry.icd10_desc,
        recorded_date: entry.recorded_date,
        valid_drugs: entry.matched_jcodes
          ? entry.matched_jcodes.join(", ")
          : undefined,
        source: entry?.source ? entry.source.join(", ") : "",
      }))
    : [];
};
